import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import { FiltersGrid } from "../../styles";
import {
	FILTER_STATUS_OPTIONS,
	FILTER_VALIDITY_OPTIONS,
} from "../../utils/constants";

const FilterFields = ({ filters, campusOptions, signatureTypeOptions }) => {
	const { campusId, signatureTypeCode, status, validity, search } = filters.value;
	return (
		<FiltersGrid>
			<CustomTextInput
				label="Buscar por nombre o código"
				placeholder="Nombre visible o código UTP..."
				value={search}
				onChange={value => filters.change("search", value)}
				width={{ container: "100%" }}
			/>
			<CustomSelect
				label="Campus"
				value={campusId}
				onChange={value => filters.change("campusId", value)}
				optionsProps={campusOptions}
				defaultOptionText="Todos"
				width={{
					container: "100%",
					containerSelect: "100%",
				}}
			/>
			<CustomSelect
				label="Tipo"
				value={signatureTypeCode}
				onChange={value => filters.change("signatureTypeCode", value)}
				optionsProps={[
					{ value: "ALL", text: "Todos" },
					...(signatureTypeOptions || []),
				]}
				defaultOptionText="Todos"
				width={{
					container: "100%",
					containerSelect: "100%",
				}}
			/>
			<CustomSelect
				label="Estado"
				value={status}
				onChange={value => filters.change("status", value)}
				optionsProps={FILTER_STATUS_OPTIONS}
				width={{
					container: "100%",
					containerSelect: "100%",
				}}
			/>
			<CustomSelect
				label="Vigencia"
				value={validity}
				onChange={value => filters.change("validity", value)}
				optionsProps={FILTER_VALIDITY_OPTIONS}
				width={{
					container: "100%",
					containerSelect: "100%",
				}}
			/>
		</FiltersGrid>
	);
};

export default FilterFields;
